// @flow
import React, {useEffect} from 'react';
import {observer} from "mobx-react-lite";
import AuthModal from "./AuthModal";
import t from "../trans";
import rootStore from "../stores";
import NotificationActions from "../actions/NotificationActions";
import global from "../Grobot/Global";
import WebApi from "../WebApi";
import {getCurrentPage} from "../util";


const AuthUser = observer(() => {
    const sessionStore = rootStore.sessionStore;

    useEffect(() => {
            if (sessionStore.hasRequiredRole()) {
                global.grobot_init();
            } else {
                // Set default langugage:
                global.set_default_lang();
            }
        },
        [sessionStore.status, sessionStore.requiredRole]);

    if (!sessionStore.hasRequiredRole()) {
        global.set_default_lang();
        return (
            <AuthModal
                title={t("Please log in as") + ": " + sessionStore.getRequiredRoleName()}
                onClickOk={(user, password) => {
                    NotificationActions.clear.defer();
                    sessionStore.logon(user, password).then(() => {
                        // WebApi.authorization("Bearer " + sessionStore.getSession().token);
                    });
                }}
                onClickCancel={() => {
                    // Go to top page:
                    if (getCurrentPage() == "archive.html") window.location.href = "index.html";
                    else window.location.reload();
                }}
                noCancel={false}
                okText={t('OK')}
                showNotifications={true}
                disabled={sessionStore.status == "in_progress"}
            />);
    } else {
        return (<div/>);
    }
});

export default AuthUser;
